<script lang="ts" setup>
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';

import * as l from './TrustSection.loc.js';

const t = useTranslate();
</script>

<template>
  <section
    id="trust"
    :class="css.trustSection"
    data-width="full"
  >
    <div :class="css.container">
      <h2 :class="css.heading">{{ t(l.heading) }}</h2>
      <ul :class="css.trustItems">
        <li :class="css.trustItem">
          <div :class="css.icon">
            <span class="material-symbols-outlined">medical_services</span>
          </div>
          <h3>{{ t(l.realCliniciansTitle) }}</h3>
          <p>{{ t(l.realCliniciansDescription) }}</p>
        </li>
        <li :class="css.trustItem">
          <div :class="css.icon">
            <span class="material-symbols-outlined">verified_user</span>
          </div>
          <h3>{{ t(l.gdprCompliantTitle) }}</h3>
          <p>{{ t(l.gdprCompliantDescription) }}</p>
        </li>
        <li :class="css.trustItem">
          <div :class="css.icon">
            <span class="material-symbols-outlined">lock</span>
          </div>
          <h3>{{ t(l.privacyByDesignTitle) }}</h3>
          <p>{{ t(l.privacyByDesignDescription) }}</p>
        </li>
        <li :class="css.trustItem">
          <div :class="css.icon">
            <span class="material-symbols-outlined">psychology_alt</span>
          </div>
          <h3>{{ t(l.noModelTrainingTitle) }}</h3>
          <p>{{ t(l.noModelTrainingDescription) }}</p>
        </li>
        <li :class="css.trustItem">
          <div :class="css.icon">
            <span class="material-symbols-outlined">visibility_off</span>
          </div>
          <h3>{{ t(l.physicianAccessTitle) }}</h3>
          <p>{{ t(l.physicianAccessDescription) }}</p>
        </li>
        <li :class="css.trustItem">
          <div :class="css.icon">
            <span class="material-symbols-outlined">verified</span>
          </div>
          <h3>{{ t(l.registeredEntityTitle) }}</h3>
          <p>{{ t(l.registeredEntityDescription) }}</p>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" module="css">
.trustSection {
  background: $color-patient-950;
  color: $color-white;
  padding: var(--space-large) 0;
}

.container {
  max-width: var(--container-large);
  margin: 0 auto;
  padding: 0 var(--padding-global);

  @media screen and (min-width: 768px) {
    padding: 0 var(--padding-global);
  }
}

.heading {
  font-size: var(--font-size-heading-2);
  text-align: center;
  margin: 0 0 var(--space-large) 0;
  font-weight: $font-weight-600;
  letter-spacing: $letter-spacing-heading-2;
}

.trustItems {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: var(--space-large);
  grid-template-columns: repeat(1, 1fr);

  @media screen and (min-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--space-medium);
  }

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.trustItem {
  h3 {
    font-size: var(--font-size-text-large);
    margin: 1rem 0 0.5rem 0;
    font-weight: $font-weight-600;
    letter-spacing: $letter-spacing-heading-3;
  }

  p {
    color: $opacity-white-60;
    margin: 0;
    font-size: var(--font-size-text-small);
  }
}

.icon {
  span {
    display: inline-block;
    font-size: var(--font-size-heading-3);
    line-height: 1;
    background: linear-gradient(135deg, $color-patient-200, $color-doctor-200);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    font-variation-settings:
      'FILL' 0,
      'wght' 300,
      'GRAD' -25,
      'opsz' 40;
  }
}
</style>
